import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];
    if (
        props.pendingGatewayVLANDisable !== undefined
        // &&
        // props.venueListUtilization !== undefined
    ) {
        console.log("pendingGatewayVLANDisable data:", props.pendingGatewayVLANDisable); // Debug log
        for (const key of Object.keys(props.pendingGatewayVLANDisable)) {
            const item = props.pendingGatewayVLANDisable[key]; // Get the actual data object
            if (item !== undefined) {
                userAttributes.push({
                    id: key,
                    venueID: item["VenueID"] || item.VenueID,
                    UnitID_internal: item["UnitID_internal"] || item.UnitID_internal,
                    vlan: item["vlan"] || item.vlan,
                    SubscriberEmail: item["SubscriberEmail"] || item.SubscriberEmail,
                    startDate: item["StartDateTimeUTC.ISO8601"] || item.StartDateTimeUTC?.ISO8601,
                    endDate: item["EndDateTimeUTC.ISO8601"] || item.EndDateTimeUTC?.ISO8601,
                    status: item["Status"] || item.Status,
                });
                i = i + 1;
            }
        }
    }
    columns = [
        {
            headerName: "Venue ID",
            field: "venueID",
            minWidth: 250,
        },
        {
            headerName: "Unit ID",
            field: "UnitID_internal",
            minWidth: 200,
        },
        {
            headerName: "VLAN",
            field: "vlan",
            minWidth: 100,
        },
        {
            headerName: "Subscriber Email",
            field: "SubscriberEmail",
            minWidth: 250,
        },
        {
            headerName: "Start Date",
            field: "startDate",
            type: "dateTime",
            valueFormatter: (value) =>
                value
                    ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                      }).format(new Date(value))
                    : "N/A",
            minWidth: 180,
        },
        {
            headerName: "End Date",
            field: "endDate",
            type: "dateTime",
            valueFormatter: (value) =>
                value
                    ? new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                      }).format(new Date(value))
                    : "N/A",
            minWidth: 180,
        },
        {
            headerName: "Status",
            field: "status",
            minWidth: 150,
        }
    ];
    rows = userAttributes;
    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 60 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
    );
}
